import { render } from "./UserStagingDetail.vue?vue&type=template&id=4e49fad5"
import script from "./UserStagingDetail.vue?vue&type=script&lang=js"
export * from "./UserStagingDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__